import React from 'react';
import styled from 'styled-components';

const SwitchContainer = styled.div`
  display: flex;
  gap: 0px;
`;

const Button = styled.button`
  padding: 5px 0;
  width: 100px;
  outline: none;
  background-color: ${props => (props.isActive ? '#e6f7ff' : 'white')};
  color: ${props => (props.isActive ? 'inherit' : '#333')};
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  border: 1px solid ${props => (props.isActive ? '#1890ff' : '#e0e0e0')};

  &:first-child {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    border-right: none;
  }

  &:last-child {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    border-left: none;
  }

  &:hover {
    background-color: ${props => (props.isActive ? '#e6f7ff' : '#f5f5f5')};
  }
`;

const Separator = styled.div`
  width: 1px;
  background-color: #007bff;
`;

const ButtonSwitch = ({ checked, onChange }) => {
  return (
    <SwitchContainer>
      <Button isActive={!checked} onClick={() => onChange(false)} type='button'>
        No
      </Button>
      <Separator />
      <Button isActive={checked} onClick={() => onChange(true)} type='button'>
        Yes
      </Button>
    </SwitchContainer>
  );
};

export default ButtonSwitch;
